import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { Link } from '../../../Resource/Types';
import TypeaheadInput from '../TypeaheadInput';
import { TypeaheadSelection } from '../TypeaheadInput/Types';
import { groupSuggestionsResourceDecoder } from './Decoders';
import { GroupSuggestion } from './Types';

interface Props {
  value: string;
  onChange: (value: string) => void;
  onSelectionChange?: (selection: TypeaheadSelection<GroupSuggestion>) => void;
  onBlur: () => void;
  placeholder: string;
  className: string;
  endpoint: Maybe<Link>;
  allowCreate?: boolean;
}

function GroupInputWithSuggestions({
  value,
  onChange,
  onSelectionChange,
  onBlur,
  placeholder,
  className,
  endpoint,
  allowCreate = true,
}: Props) {
  const renderGroupSuggestion = (group: GroupSuggestion, _index: number, _isSelected: boolean) => (
    <span>{group.name}</span>
  );

  const createLabel = (query: string) => `Create group: ${query}`;

  return (
    <TypeaheadInput<GroupSuggestion>
      value={value}
      onChange={onChange}
      onSelectionChange={onSelectionChange}
      onBlur={onBlur}
      placeholder={placeholder}
      className={className}
      endpoint={endpoint}
      decoder={groupSuggestionsResourceDecoder}
      renderSuggestion={renderGroupSuggestion}
      allowCreate={allowCreate}
      createLabel={createLabel}
      minQueryLength={2}
      debounceMs={500}
      inputType="text"
    />
  );
}

export default observer(GroupInputWithSuggestions);
